import { type Component, createSignal, Show } from 'solid-js'
import Avatar from '../../../assets/icons/Avatar'

interface UserAvatarProps {
  src?: string | null
  name?: string
  size?: number
  class?: string
}

const UserAvatar: Component<UserAvatarProps> = (props) => {
  const [hasError, setHasError] = createSignal(false)

  return (
    <Show when={props.src && !hasError()} fallback={<Avatar size={props.size ?? 8} />}>
      <img src={props.src!} alt={props.name ?? 'User avatar'} class={props.class} onError={() => setHasError(true)} />
    </Show>
  )
}

export default UserAvatar
